import { gql } from '~gql-types/gql'

export const FETCH_NETWORK_MEMBER = gql(`
  query FetchNetworkMember($networkName: String) {
    loggedInUser {
      id
      firstname
      lastname
      username
      networkUser(networkName: $networkName) {
        userId
        networkId
        role
      }
    }
  }
`)
